import React from 'react';
import { Form } from 'antd';
import SPUploadSinglePhoto from 'components/base/SPUploadSinglePhoto';
import { API_VEHICLE_UPLOAD_PHOTO } from 'hooks/carRental/_';

const LabelImage:React.FC<any> = (props) => {

  const { label, name, action, rules, accept = ".jpg,.jpeg,.png" } = props || {};

  return (
    <Form.Item
      label={label}
      name={name}
      labelCol={{ span: 12 }}
      rules={rules}
    >
      <SPUploadSinglePhoto hideTitle accept={accept} action={action || API_VEHICLE_UPLOAD_PHOTO} />
    </Form.Item>
  );
}

export default LabelImage;
